import React from 'react';
import { CircleUserRound, MessagesSquare, Search, UserRound } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router';

import {
  HamburgerButton,
  MobileDrawer,
  TeacherMobileNav,
} from 'components/MobileDrawer';
import { HeaderWalletBalance } from 'components/Wallet/HeaderWalletBalance';
import { WALLET_PUBLIC_ENABLED } from 'constants/walletPublic';
import { ChatUnreadBadge } from 'components/ChatUnreadBadge/ChatUnreadBadge';
import { NotificationBell } from 'components/NotificationBell/NotificationBell';
import { useIsMobileLayout } from 'hooks/useMediaQuery';
import logo from 'assets/images/logotype/Logo_Repetitor_Blue.svg';

import { CabinetHeaderNav, type CabinetHeaderNavItem } from './CabinetHeaderNav';
import styles from './HeaderTeacher.module.scss';

const TEACHER_NAV: CabinetHeaderNavItem[] = [
  { to: '/teacher', label: 'Профиль', Icon: UserRound, end: true },
  { to: '/teacher/search', label: 'Поиск', Icon: Search },
  { to: '/teacher/chat', label: 'Чаты', Icon: MessagesSquare, badge: <ChatUnreadBadge accent='teacher' /> },
];

const HeaderLogo = () => (
  <Link to='/teacher/search' className={styles['header-logo']}>
    <img src={logo} alt='MyTeacher.pro' />
    <div className={styles['header-logo__content']}>
      <h4>MYTEACHER</h4>
      <span>PRO</span>
    </div>
  </Link>
);

/* Figma 18:2645 / 66:2485: справа колокол и профиль, непрочитанные чаты - бейдж на пункте пилюли.
   Figma 18:2905 (360): логотип слева, меню справа; чаты и профиль в выдвижном меню, колокол оставлен. */
const HeaderContent = ({ menuButton }: { menuButton?: React.ReactNode }) => (
  <div className={styles['header-content']}>
    <NotificationBell />
    {WALLET_PUBLIC_ENABLED ? <HeaderWalletBalance /> : null}
    {menuButton ?? (
      <NavLink to='/teacher' aria-label='Профиль' className={styles.profileLink}>
        <CircleUserRound size={28} strokeWidth={2} aria-hidden className={styles.profileIcon} />
      </NavLink>
    )}
  </div>
);

export const HeaderTeacher = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const isMobile = useIsMobileLayout();
  const location = useLocation();

  React.useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <header className={styles.header}>
      <div className={styles['header-wrapper-content']}>
        <div className={styles['header-leading']}>
          <HeaderLogo />
        </div>

        <CabinetHeaderNav items={TEACHER_NAV} className={styles['header-navigation']} />

        <HeaderContent
          menuButton={
            isMobile ? (
              <HamburgerButton open={drawerOpen} onClick={() => setDrawerOpen((prev) => !prev)} />
            ) : undefined
          }
        />
      </div>

      {isMobile && (
        <MobileDrawer
          open={drawerOpen}
          onClose={closeDrawer}
          title='Меню репетитора'
          accent='teacher'
        >
          <TeacherMobileNav onNavigate={closeDrawer} />
        </MobileDrawer>
      )}
    </header>
  );
};
